import { render, staticRenderFns } from "./BlockedCusipsWidget.vue?vue&type=template&id=5c68fe3c&"
import script from "./BlockedCusipsWidget.vue?vue&type=script&lang=js&"
export * from "./BlockedCusipsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports